import { EventEmitter, OnInit, NgZone, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AddOpportunityService } from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import { SharedModalService } from "@app/shared-modal/service/shared-modal.service";
import { AuthService } from "@app/core";
var CallLogModalComponent = /** @class */ (function () {
    function CallLogModalComponent(fb, opportunityService, sharedModalService, zone, authService, confirmationBoxHelper, ajsScope) {
        var _this = this;
        this.fb = fb;
        this.opportunityService = opportunityService;
        this.sharedModalService = sharedModalService;
        this.zone = zone;
        this.authService = authService;
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.ajsScope = ajsScope;
        this.callType = [{ id: 'Incoming Call', value: 'Inbound call' }, { id: 'Outgoing Call', value: 'Outbound call' }];
        this.scheduled = true;
        this.subscriptions = {};
        this.callActivityShow = false;
        this.activityIsScheduled = [];
        this.completed = true;
        this.saveDisabled = false;
        this.isContactNotFound = false;
        this.showAddNewTemplate = false;
        this.showTemplateList = false;
        this.customTagsList = [];
        this.customFields = [];
        this.customFieldsDirectResponse = null;
        this.showRecommendation = false;
        this.isCallCustomFieldEnabled = false;
        this.showCallLogModal = false;
        this.showCallCustomFields = false;
        this.showCallNoteTemplateOption = false;
        this.onSave = new EventEmitter();
        this.onClose = new EventEmitter();
        this.users = [];
        this.selectedUsersList = [];
        this.screen = '';
        this.onChange = function () {
            var message = _this.callForm.value.note;
            if (_this.showCallNoteTemplateOption) {
                _this.customTagsList.forEach(function (ct) {
                    if (!message.includes(">{" + ct.name + "}</") && !_this.customTagForm.controls[ct.name].value) {
                        _this.customTagForm.controls[ct.name].setValidators(Validators.nullValidator);
                        _this.customTagForm.controls[ct.name].disable();
                    }
                });
            }
        };
        this.isCallCustomFieldEnabled = this.authService.permitted(['UseCallFields.readaccess']) === true;
    }
    CallLogModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.customTagForm = this.fb.group({});
        if (this.showCallCustomFields) {
            this.opportunityService.listCallCustomFields().subscribe(function (res) {
                _this.getCustomFieldCall = res;
                _this.buildCustomeFieldForm(res);
                _this.customFieldsDirectResponse = res['customCallField'];
                // To show the list in this specific order, we mapped like this
                if (res['customCallField']['Reason for call']) {
                    _this.customFields.push({ key: 'Reason for call', value: res['customCallField']['Reason for call'] });
                }
                if (res['customCallField']['Type of call']) {
                    _this.customFields.push({ key: 'Type of call', value: res['customCallField']['Type of call'] });
                }
                if (res['customCallField']['Outcome of call']) {
                    _this.customFields.push({ key: 'Outcome of call', value: res['customCallField']['Outcome of call'] });
                }
            });
        }
        this.getUserList();
    };
    CallLogModalComponent.prototype.buildCustomeFieldForm = function (field) {
        var csof = {};
        Object.entries(field['customCallField']).forEach(function (item) {
            csof[item[0]] = new FormControl('', Validators.required);
        });
        this.customFieldForm = this.fb.group(csof);
    };
    CallLogModalComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.showCallLogModal) {
            if (this.editCallData &&
                this.editCallData.communications &&
                this.editCallData.communications.opportunity) {
                this.screen = 'opportunity_notes';
                this.getUserList();
            }
            if (this.getCustomFieldCall) {
                this.buildCustomeFieldForm(this.getCustomFieldCall);
            }
            if (this.showCallLogModal) {
                this.getUserList();
                if (this.editCallData == null) {
                    var showContent = 'call';
                    if (this.activityList) {
                        /* for (var filter = 0; filter < this.activityList.length; filter++) {
                             // for (var record = 0; record < this.activityList[filter]['records'].length; record++) {
                                 if (this.activityList[filter]['isScheduled'] == 'true' && this.activityList[filter]['activityStatus'] != 'Completed'
                                     && this.activityList[filter]['activityType'].toLowerCase() == showContent.toLowerCase())
                                     this.activityIsScheduled.push(this.activityList[filter])
                             // }
                         }*/
                        if (this.activityList.length != 0 && this.activityList[0].length != 0) {
                            this.callActivityShow = true;
                            for (var i = 0; i <= this.activityList[1].length; i++) {
                                if (this.activityList[1][i] && this.activityList[1][i].template) {
                                    this.selectedCallNoteTemplate = this.activityList[1][i].template;
                                    this.showRecommendation = true;
                                    break;
                                }
                            }
                            this.completed = true;
                        }
                        else {
                            this.callActivityShow = false;
                            this.completed = false;
                        }
                    }
                    if (this.completedActivityData && (this.completedActivityData.template || this.completedActivityData.templateName)) {
                        this.selectedCallNoteTemplate = this.completedActivityData;
                        this.showRecommendation = true;
                    }
                    this.buildForm();
                    setTimeout(function () {
                        _this.todayActivity();
                    }, 500);
                    $(".modal-header").css("background", "#5E7F7D");
                    $('.callLogModal').modal('show');
                    $(".modal-dialog").addClass("modal-dialog-open");
                    // setTimeout(() => {
                    //     this.updateTinyMCEValues();
                    // }, 100);
                }
                else {
                    if (this.editCallData['activityType'] == 'Call') {
                        this.editId = this.editCallData.communications.phoneId;
                        this.callActivityShow = false;
                        this.buildForm();
                        this.callForm.patchValue({
                            "contactTelephoneId": this.editCallData.communications.contactNumberId,
                            "note": this.editCallData.communications.phoneCallNote,
                            "callType": this.editCallData.communications.calltype
                        });
                        setTimeout(function () {
                            var cfs = _this.editCallData.communications['customFields'];
                            var editedCfs = {};
                            Object.entries(cfs).forEach(function (kvArray) {
                                if (kvArray[1]) {
                                    editedCfs[kvArray[0]] = _this.customFieldsDirectResponse[kvArray[0]].find(function (f) { return f.id == kvArray[1]; });
                                }
                            });
                            _this.customFieldForm.patchValue(editedCfs);
                            // increased 500 ms extra to get customFieldsDirectResponse
                        }, 1500);
                        $(".modal-header").css("background", "#5E6D7F");
                        $('#modalPopUp').modal('show');
                        // $(".modal-dialog").css("height", "450px");
                        $(".modal-dialog").addClass("modal-dialog-open");
                        $('.callLogModal').addClass('in');
                        // setTimeout(() => {
                        //     this.updateTinyMCEValues();
                        // }, 100);
                    }
                }
            }
        }
        if (this.completedActivityData && (this.completedActivityData['template'] == null || (this.completedActivityData['template']['name'] == null && this.completedActivityData['template']['customTags'] == null && this.completedActivityData['template']['message'] == null))) {
            // this.showCallNoteTemplateOption = false;
            this.showRecommendation = false;
            this.getUserList();
        }
        if (changes.customerId && this.customerId) {
            this.getCustomerCall();
        }
    };
    CallLogModalComponent.prototype.getCustomerCall = function () {
        var _this = this;
        this.opportunityService.getCustomerContact(this.customerId).subscribe(function (data) {
            if (Object.values(data).length) {
                _this.customerCallDetails = data;
            }
            else {
                _this.isContactNotFound = true;
            }
        });
    };
    CallLogModalComponent.prototype.todayActivity = function () {
        var _this = this;
        this.opportunityService.getScheduledEmail(this.opportunityId, 'Call').subscribe(function (resp) {
            if (resp) {
                if (resp.length && resp[0].length) {
                    _this.callActivityShow = true;
                    _this.completed = true;
                    _this.todayActivityId = resp[0];
                }
                else {
                    _this.callActivityShow = false;
                    _this.completed = false;
                }
            }
        });
    };
    CallLogModalComponent.prototype.isFieldsValid = function (cf) {
        var isValidElement = cf.find(function (cfElement) { return cfElement.archived === 0; });
        return this.editId ? true : !!isValidElement;
    };
    CallLogModalComponent.prototype.buildForm = function () {
        this.callForm = this.fb.group({
            "contactTelephoneId": ["", Validators.required],
            "activityType": ["Call"],
            "note": [""],
            "customerId": [""],
            "callType": ["Outgoing Call", Validators.required]
        });
    };
    CallLogModalComponent.prototype.closeModal = function (emitEvent) {
        if (emitEvent === void 0) { emitEvent = true; }
        this.editId = null;
        this.callForm.controls['activityType'].setValue('');
        this.callForm.controls['customerId'].setValue('');
        this.callForm.controls['note'].setValue('');
        this.editCallData = undefined;
        this.scheduledData = undefined;
        if (this.screen == 'opportunity_call_log' || this.screen == 'opportunity') {
            this.scheduled = true;
        }
        else {
            this.scheduled = false;
        }
        this.activityIsScheduled = [];
        this.callActivityShow = false;
        this.showTemplateList = false;
        this.customTagForm = new FormGroup({});
        this.customFieldForm.reset();
        this.customTagsList = [];
        this.showRecommendation = false;
        this.completedActivityData = null;
        this.selectedCallNoteTemplate = null;
        $('.callLogModal').modal('hide');
        $("#call-log-modal-dialogue").removeClass("modal-dialog-open");
        if (emitEvent)
            this.onClose.emit(false);
    };
    CallLogModalComponent.prototype.isScheduledActivity = function (event) {
        this.scheduled = event.target.checked;
    };
    CallLogModalComponent.prototype.completeActivity = function (event) {
        this.completed = event.target.checked;
    };
    CallLogModalComponent.prototype.saveCall = function () {
        var _this = this;
        this.saveDisabled = true;
        this.callForm.get('customerId').setValue(this.customerId);
        var callData = this.callForm.value;
        if (this.completed) {
            callData = this.callForm.value;
            var activityId = this.todayActivityId;
            /*if (this.activityIsScheduled.length != 0) {
                for (var i = 0; i < this.activityIsScheduled.length; i++) {
                    activityId.push(this.activityIsScheduled[i]['activity_id'])
                }
            } else {
                if (this.scheduledData) {
                    if (this.scheduledData.hasOwnProperty('activity_id')) {
                        activityId.push(this.scheduledData.activity_id)
                    } else {
                        activityId.push(this.scheduledData.activityId)
                    }
                }
            }*/
            callData.activityIds = activityId;
            if (this.todayActivityId) {
                callData.activityIds = this.todayActivityId;
            }
        }
        if (this.customTagsList && this.customTagsList.length) {
            callData.customTags = this.customTagForm.value;
        }
        if (this.customFieldForm.valid && this.customFieldForm.value) {
            callData.callCustomField = this.customFieldForm.value;
        }
        // this.editId = event.editId;
        // callData.activityIds = this.activityEmail;
        var url;
        if (this.editId) {
            callData['opportunityId'] = this.opportunityId;
            this.screen == 'opportunity_notes' ? callData['communicationId'] = this.editCallData.communications.tablePkId : callData['communicationId'] = this.editCallData.communications.communicationId;
            url = "sales/edit_opportunity_call/" + this.editId;
        }
        else {
            url = "sales/opportunityActivityCall/" + this.opportunityId;
        }
        callData['selectedUsersList'] = this.selectedUsersList.length > 0 ? this.selectedUsersList : [];
        this.opportunityService.createOpportunityCall(callData, url).subscribe(function (data) {
            _this.sharedModalService.updateModalStatus('opportunity', 'call', false);
            // If this schedule, open the schedule activity modal
            _this.onSave.emit(_this.scheduled);
            _this.closeModal();
            _this.saveDisabled = false;
            // if (this.scheduledData) {
            //     if (this.scheduledData.hasOwnProperty('activityId')) {
            _this.opportunityService.refreshCompleteActivity('complete');
            //     }
            // }
        });
    };
    CallLogModalComponent.prototype.closeModalConfirmation = function () {
        var _this = this;
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the log call?', this.ajsScope)
            .then(function () {
            _this.closeModal();
        }).catch(function () { });
    };
    CallLogModalComponent.prototype.setTemplateDetails = function (selectedTemplate) {
        var _this = this;
        selectedTemplate.message = selectedTemplate.message ? selectedTemplate.message : selectedTemplate.value;
        selectedTemplate.message = selectedTemplate.template ? selectedTemplate.template.message : selectedTemplate.message;
        this.callForm.controls['note'].setValue(selectedTemplate['message']);
        if (selectedTemplate.customTags || (selectedTemplate.template && selectedTemplate.template.customTags)) {
            this.customTagForm = new FormGroup({});
            var customTagsList = JSON.parse(selectedTemplate.customTags || selectedTemplate.template.customTags);
            customTagsList = customTagsList.map(function (ct) {
                ct.name = ct.name.replaceAll('{', '').replaceAll('}', '');
                _this.customTagForm.addControl(ct.name, new FormControl('', Validators.required));
                return ct;
            });
            this.customTagsList = customTagsList;
        }
        else {
            this.customTagsList = [];
            this.customTagForm = new FormGroup({});
        }
        // this.updateTinyMCEValues();
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    };
    CallLogModalComponent.prototype.showTemplateOptions = function () {
        $(".template-wrapper").addClass("template-open");
        this.showTemplateList = true;
        $("#emailcontent").addClass("overlay");
    };
    CallLogModalComponent.prototype.cancelTemplate = function () {
        $("#emailcontent").removeClass("overlay");
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    };
    CallLogModalComponent.prototype.replaceCustomTags = function (tagName) {
        var replacingValue = this.customTagForm.value[tagName.replaceAll('{', '').replaceAll('}', '')];
        if (replacingValue) {
            var iframe = $('quill-editor');
            var cts = $("span[data-value='" + tagName + "']", iframe.contents());
            cts.each(function (index, ct) {
                $(ct).find('span').html(replacingValue);
                $(ct).removeClass('mention custom_tag');
            });
            var updatedNote = iframe.contents().find('.ql-editor')[0].innerHTML;
            this.callForm.controls.note.setValue(updatedNote);
        }
    };
    CallLogModalComponent.prototype.ngOnDestroy = function () {
        this.opportunityService.refreshCompleteActivity(null);
        this.customFields = [];
    };
    CallLogModalComponent.prototype.onContentChange = function (event) {
        if (event.text === '\n') {
            this.saveDisabled = true;
        }
        else {
            this.saveDisabled = false;
        }
        this.onChange();
        var contentEl = $(event.html).find('[data-denotation-char=""]');
        this.selectedUsersList = [];
        if (contentEl.length) {
            var _loop_1 = function (i) {
                var index = this_1.selectedUsersList.findIndex(function (data) { return data == contentEl[i].dataset['id']; });
                if (index < 0) {
                    this_1.selectedUsersList.push(contentEl[i].dataset['id']);
                }
            };
            var this_1 = this;
            for (var i = 0; i < contentEl.length; i++) {
                _loop_1(i);
            }
        }
    };
    CallLogModalComponent.prototype.getUserList = function () {
        if (this.usersList) {
            for (var index = 0; index < this.usersList.length; index++) {
                this.usersList[index]['value'] = this.usersList[index]['username'];
                this.users.push(this.usersList[index]);
            }
        }
    };
    return CallLogModalComponent;
}());
export { CallLogModalComponent };
